import { InjectionToken } from '@angular/core';
import type { ThreatmetrixConfig } from './threatmetrix.interface';

export const THREATMETRIX_CONFIG = new InjectionToken<ThreatmetrixConfig>(
  'ThreatmetrixConfig',
);
